import React from 'react';

interface ITimeStampProps {
    value: Date;
    defaultValueIfNull?: string;
}

export default function Timestamp(props: ITimeStampProps) {
    let value = props.value;
    if (value === undefined || value === null)
        return <>{props.defaultValueIfNull}</>;
    return <>{value.toISOString().split('T')[0]} {value.toTimeString().split(' ')[0]}</>
}
